import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Alert, Layout, Icon, Popconfirm, Tooltip } from 'antd';
import Button from '../../../../components/Button/Button';
import Report from '../../components/Report/Report';
import HazardIndexGrouping from '../../components/HazardIndexGrouping/HazardIndexGrouping';
import { hazardIndexSelector, loadingHazardIndexSelector } from '../../../Industry/IndustrySelectors';
import { clearReportCustomization, fetchReportCustomization } from '../../ReportActions';
import './TailoredReport.scss';

const { Content, Header } = Layout;

const TailoredReport = ({
  fullscreen,
  setFullscreen,
  hazardIndexes,
  loadingHazardIndex,
  clearReportCustomization,
  fetchReportCustomization,
}) => {
  const [page, setPage] = useState('tailor');
  const hasNoHazardIndex = !loadingHazardIndex && Array.isArray(hazardIndexes) && hazardIndexes.length === 0;
  const unavailableDownloadMessage =
    'This report is not available for download because no hazard index data is available for this industry.';

  const location = useLocation();
  useEffect(() => {
    const query = new URLSearchParams(location.search);
    if (query.get('tmpl')) {
      fetchReportCustomization(query.get('tmpl'));
    }
  }, [location, fetchReportCustomization]);

  switch (page) {
    case 'tailor': {
      return (
        <Content>
          <Header className="report-header">
            <h3>Tailored Report</h3>
            <Popconfirm
              title="Are you sure to start over?"
              onConfirm={() => clearReportCustomization()}
              okText="Yes"
              cancelText="No"
            >
              <Button secondary style={{ marginLeft: 'auto', marginRight: '20px' }}>
                <Icon type="reload" /> Reset
              </Button>
            </Popconfirm>
            <Tooltip title={hasNoHazardIndex ? unavailableDownloadMessage : null} placement="bottomRight">
              <span className="tailored-next-wrap">
                <Button secondary type="primary" disabled={hasNoHazardIndex} onClick={() => setPage('report')}>
                  Next <Icon type="right" />
                </Button>
              </span>
            </Tooltip>
          </Header>
          <main className="tailor-main">
            <h3>REPORT / HAZARD ASSESSMENT</h3>
            <div className="tailor-description">
              To tailor this report for your client, <strong>drag and drop</strong> the insurance classes below to their
              respective categories and add your comments to each.
            </div>
            <div className="drop-container">
              {hasNoHazardIndex ? (
                <Alert
                  className="report-unavailable-alert"
                  type="warning"
                  showIcon
                  message="Report not available for download"
                  description={unavailableDownloadMessage}
                />
              ) : (
                <HazardIndexGrouping appearance="page" />
              )}
            </div>
          </main>
        </Content>
      );
    }
    case 'report': {
      return (
        <Report
          handleBack={() => {
            setPage('tailor');
          }}
          fullscreen={fullscreen}
          setFullscreen={setFullscreen}
          type="Tailored Report"
        />
      );
    }
    default:
      return <div />;
  }
};

const mapStateToProps = (state) => ({
  hazardIndexes: hazardIndexSelector(state),
  loadingHazardIndex: loadingHazardIndexSelector(state),
});

const mapDispatchToProps = { clearReportCustomization, fetchReportCustomization };

export default connect(mapStateToProps, mapDispatchToProps)(TailoredReport);
